import { QuoteStatusToDealStageMappingForm } from '@monetize/types/app';
import { FC } from 'react';
import {
  Control,
  FieldArrayWithId,
  FieldErrors,
  UseFormHandleSubmit,
} from 'react-hook-form';
import {
  MAlert,
  MButton,
  MDivider,
  MFlex,
} from '../../../../../../../components/Monetize';
import { MappingRow } from './MappingRow';

interface MappingFormProps {
  fields: FieldArrayWithId<
    QuoteStatusToDealStageMappingForm,
    'mappings',
    'id'
  >[];
  control: Control<QuoteStatusToDealStageMappingForm>;
  handleSubmit: UseFormHandleSubmit<QuoteStatusToDealStageMappingForm>;
  onSubmit: (data: QuoteStatusToDealStageMappingForm) => void;
  isDirty: boolean;
  isSaving: boolean;
  errors: FieldErrors<QuoteStatusToDealStageMappingForm>;
  quoteStatuses: Array<{ label: string; value: string }>;
  dealStages: Array<{ label: string; value: string }>;
}

export const MappingForm: FC<MappingFormProps> = ({
  fields,
  control,
  handleSubmit,
  onSubmit,
  isDirty,
  isSaving,
  errors,
  quoteStatuses,
  dealStages,
}) => {
  return (
    <MFlex direction="column" align="flex-start">
      <MFlex
        as="form"
        direction="column"
        gap={4}
        w="full"
        mt={2}
        onSubmit={handleSubmit(onSubmit)}
      >
        {fields.map((field, idx) => (
          <MappingRow
            key={field.id}
            index={idx}
            control={control}
            quoteStatuses={quoteStatuses}
            dealStages={dealStages}
            errors={errors}
          />
        ))}
      </MFlex>
      <MDivider w="full" mt={2} />
      <MFlex
        direction="row"
        align="center"
        justify="right"
        gap={4}
        mt={4}
        w="full"
      >
        {isDirty && (
          <MAlert
            type="warning"
            alertProps={{ px: 2, py: 1 }}
            alertIconProps={{ width: 4, height: 4 }}
            alertDescriptionProps={{ fontSize: 'sm' }}
          >
            Unsaved Changes
          </MAlert>
        )}
        <MButton
          variant="primary"
          type="submit"
          isDisabled={!isDirty || isSaving}
          isLoading={isSaving}
          onClick={handleSubmit(onSubmit)}
        >
          Save
        </MButton>
      </MFlex>
    </MFlex>
  );
};
